import React from 'react';
import { Icon } from '@iconify/react';

const MiniCard = ({ styleType, className = '', label }) => {
    return (
        <div className={`w-16 h-20 rounded-lg shadow-md flex flex-col p-1.5 relative overflow-hidden transition-all duration-300 hover:scale-110 bg-white border border-gray-100 group ${className}`}>
            {styleType === 'minimal' && (
                <div className="bg-[#F5F5F0] w-full h-full rounded border border-gray-100 flex flex-col items-center justify-center gap-1">
                    <div className="w-6 h-6 bg-gray-300 rounded-full"></div>
                    <div className="w-8 h-1 bg-gray-300 rounded"></div>
                </div>
            )}
            {styleType === 'bold' && (
                <div className="bg-yellow-400 w-full h-full rounded border border-black flex items-center justify-center">
                    <span className="font-black text-[10px] italic tracking-tighter">BOLD</span>
                </div>
            )}
            {styleType === 'glass' && (
                <div className="bg-gradient-to-br from-purple-500 to-pink-500 w-full h-full rounded flex items-center justify-center relative overflow-hidden">
                    <div className="w-10 h-6 bg-white/20 backdrop-blur-md border border-white/30 rounded-sm transform rotate-12"></div>
                </div>
            )}
        </div>
    );
};

export const StyleGeneratorVisual = () => {
  return (
    <div className="relative w-full h-full flex flex-col items-center justify-center pt-2">

        {/* Connecting Lines */}
        <svg className="absolute w-full h-full top-0 left-0 pointer-events-none" style={{zIndex: 0}}>
            <path d="M150 135 Q 150 100 90 80" stroke="#E5E7EB" strokeWidth="2" fill="none" strokeDasharray="4 4" />
            <path d="M150 135 L 150 90" stroke="#E5E7EB" strokeWidth="2" fill="none" strokeDasharray="4 4" />
            <path d="M150 135 Q 150 100 210 80" stroke="#E5E7EB" strokeWidth="2" fill="none" strokeDasharray="4 4" />
        </svg>

        {/* Styles Row */}
        <div className="flex gap-6 mb-8 z-10">
            <div className="relative">
                <MiniCard styleType="minimal" label="Minimal" className="transform rotate-[-8deg] hover:rotate-0 hover:z-20" />
            </div>

            <div className="relative mt-[-10px]">
                <MiniCard styleType="bold" label="Bold" className="transform hover:z-20" />
            </div>

            <div className="relative">
                <MiniCard styleType="glass" label="Glass" className="transform rotate-[8deg] hover:rotate-0 hover:z-20" />
            </div>
        </div>

        {/* Source Asset Button */}
        <div className="bg-blue-100 text-blue-900 px-4 py-1.5 rounded-full shadow-xl z-20 flex items-center gap-2 cursor-pointer hover:bg-blue-200 transition-colors">
            <Icon icon="mdi:palette" width={10} />
            <span className="text-[10px] font-bold">Generate Variations</span>
        </div>
    </div>
  );
};

export default StyleGeneratorVisual;
